// Figma ex7axZ21JT9w5UShRn65vm, section 55:1015 (Bugaboo), frames 55:1016 (cover), 55:1056, 55:1088
import type { Case, Img } from "../types"

const own = (n: string, w: number, h: number): Img => {
    const src = `/work/bugaboo/${n}`
    return { id: src, src, w, h, widths: [...[800, 1600].filter((x) => x < w), w] }
}
const IMG = own

export const bugaboo: Case = {
    name: "Bugaboo",
    theme: {
        page: "#e1e1e1",
        gradient: "linear-gradient(180deg, #e1e1e1 0%, #ffffff 100%)",
        stops: [
            [225, 225, 225, 0],
            [255, 255, 255, 1],
        ],
        fill: "#ffffff",
        line: "#000000",
        tone: "light",
        title: "#000000",
        body: "rgba(0, 0, 0, 0.6)",
    },
    modules: [
        {
            type: "grid",
            columns: [
                {
                    w: 220,
                    cells: [
                        {
                            h: 220,
                            tag: {
                                logo: "/work/bugaboo/logo.png",
                                logoBox: [20, 22, 132, 26],
                                text: "BUGABOO\nPUSH CHAIRS\nSINCE 2007\n\n.COM",
                                ink: "#000000",
                            },
                        },
                        { h: 626 },
                    ],
                },
                {
                    w: 443,
                    cells: [
                        {
                            h: 400,
                            card: {
                                title: "At the forefront of pushchair innovation",
                                body: "Through innovation and design, Bugaboo leads the way when it comes down to pushchairs. This award-winning platform is the brand's main consumer-facing gateway. Designed and developed together with Leon van Zijl, Franklin Schamhart, Niomi Consten, among others.",
                            },
                        },
                        { h: 443, image: IMG("1-1", 886, 886), phone: false },
                    ],
                },
                { w: 443, cells: [{ h: 846, image: IMG("1-2", 886, 1692) }] },
                { w: 442, cells: [{ h: 298 }, { h: 545, image: IMG("1-3", 884, 1090), phone: false }] },
            ],
        },
        { type: "grid", columns: [{ w: 1557, cells: [{ h: 846, image: IMG("2-1", 3114, 1692) }] }] },
        {
            type: "grid",
            phoneMiddle: true,
            columns: [
                {
                    w: 666,
                    cells: [
                        { h: 422, keep: true, image: IMG("3-1", 1332, 844) },
                        { h: 422, w: 443, end: true, image: IMG("3-2", 886, 844), phone: false },
                    ],
                },
                { w: 888, cells: [{ h: 846, keep: true, image: IMG("3-3", 1776, 1692) }] },
            ],
        },
    ],
}
